export default __webpack_public_path__ + "static/media/linkedin.79153426.svg";